import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, publishLast, publishReplay, refCount, switchMap } from 'rxjs/operators';
import { deserialize } from 'santee-dcts';
import { Settings } from '../../../core';
import { EQueryReopenData } from '../models/e-query-reopen-data';
import { CoordinatorEQueryDetails } from '../models/e-query-details/coordinator-e-query-details';

@Injectable()
export class CoordinatorEQueryDetailsStorage {
    constructor(
        protected readonly settings: Settings,
        protected readonly http: HttpClient) {
    }

    public getEQueryDetails(eQueryId$: Observable<number>): Observable<CoordinatorEQueryDetails> {
        return eQueryId$.pipe(
            switchMap(eQueryId => this.loadEQueryDetails(`${this.settings.apiUrl}/coordinator/e-queries/${eQueryId}`)),
            publishReplay(1),
            refCount(),
        );
    }

    public closeEQuery(eQueryId: number, reason: string): Promise<void> {
        return this.http.post<void>(`${this.settings.apiUrl}/coordinator/e-queries/${eQueryId}/close`, {
                                  reason: reason
                              },    {reportProgress: true}).toPromise();
    }


    public reopenEQuery(eQueryId: number, reopenData: EQueryReopenData): Promise<void> {
        const formData: FormData = new FormData();
        if (reopenData.files) {
            const fileContent = reopenData.files.keys();

            for (let file of fileContent) {
                formData.append('file', file, file.name);
            }
        }
        formData.append('eQueryReopenPostRequest', JSON.stringify(reopenData));
        return this.http.post<void>(`${this.settings.apiUrl}/coordinator/e-queries/${eQueryId}/re-open`, formData,
                                    { reportProgress: true }).toPromise();
    }

    private loadEQueryDetails( url: string): Observable<CoordinatorEQueryDetails> {
        return this.http.get<object>(url)
            .pipe(
                map((response) => {
                    return deserialize(response, CoordinatorEQueryDetails);
                }),
                publishLast(),
                refCount(),
            );
    }
}
